import { defineTrpcContract, mutation, query } from "@amtana/module";

import {
  archiveProjectsInputSchema,
  archiveProjectsOutputSchema,
  createProjectInputSchema,
  listProjectsInputSchema,
  projectListSchema,
  projectSchema,
  renameProjectInputSchema,
  selectProjectInputSchema,
  unarchiveProjectInputSchema,
} from "./project.schemas.ts";

export const projectTrpcContract = defineTrpcContract("project", {
  list: query({ input: listProjectsInputSchema, output: projectListSchema }),
  create: mutation({ input: createProjectInputSchema, output: projectSchema }),
  rename: mutation({ input: renameProjectInputSchema, output: projectSchema }),
  archive: mutation({ input: archiveProjectsInputSchema, output: archiveProjectsOutputSchema }),
  unarchive: mutation({ input: unarchiveProjectInputSchema, output: projectSchema }),
  select: mutation({ input: selectProjectInputSchema, output: projectSchema }),
});
